export default __webpack_public_path__ + "static/media/cartoonCook.d6e0afe0.png";